var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2169 8.25261L13.7813 10.9597C14.08 11.2084 14.0715 11.6362 13.7632 11.8751C13.5015 12.078 13.1128 12.0721 12.8588 11.8614L10.5 9.33367L8.14117 11.8614C7.88719 12.0721 7.49846 12.078 7.23678 11.8751C6.92847 11.6362 6.92001 11.2084 7.21867 10.9597L9.78313 8.25261C9.78313 8.25261 10.0763 8.02344 10.5 8.02344C10.9237 8.02344 11.2169 8.25261 11.2169 8.25261Z",
    fill: "#626262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2169 8.25261L13.7813 10.9597C14.08 11.2084 14.0715 11.6362 13.7632 11.8751C13.5015 12.078 13.1128 12.0721 12.8588 11.8614L10.5 9.33367L8.14117 11.8614C7.88719 12.0721 7.49846 12.078 7.23678 11.8751C6.92847 11.6362 6.92001 11.2084 7.21867 10.9597L9.78313 8.25261C9.78313 8.25261 10.0763 8.02344 10.5 8.02344C10.9237 8.02344 11.2169 8.25261 11.2169 8.25261Z",
    fill: "#69707D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.85fcdee4ec332035344459a125814ea9.svg";
export { ForwardRef as ReactComponent };